var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup33(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 164.684,
    height: 136.096,
    viewBox: "0 0 164.684 136.096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(-1394.97 -1575.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M2515.314,619.365a8.683,8.683,0,0,0,7.835,5.2,8.389,8.389,0,0,0,4.411-1.162l13.013-7.521,10.351-5.981,2.244-1.3,2.29-1.325a6.791,6.791,0,0,0,.982-.668,8.633,8.633,0,0,0-.866-14.234c-.035-.017-.076-.058-.116-.075l-27.9-16.105a8.63,8.63,0,0,0-12.281,4.033,8.956,8.956,0,0,0-.691,3.447v10.3h-28.8a34.731,34.731,0,0,0-34.691,34.691v28.789a34.731,34.731,0,0,0,34.691,34.692h14.856a5.812,5.812,0,0,0,0-11.624h-14.856a23.094,23.094,0,0,1-23.067-23.068V628.667a23.094,23.094,0,0,1,23.067-23.067h28.8v10.3a8.353,8.353,0,0,0,.726,3.464",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M2581.089,593.976h-8.963a5.812,5.812,0,1,0,0,11.624h8.963a23.093,23.093,0,0,1,23.067,23.067v28.789a23.093,23.093,0,0,1-23.067,23.068h-21.306v-10.3a8.337,8.337,0,0,0-.727-3.464,8.68,8.68,0,0,0-7.834-5.2,8.38,8.38,0,0,0-4.412,1.162l-13.013,7.521-10.351,5.98-2.243,1.3-2.29,1.325a6.839,6.839,0,0,0-.983.669,8.632,8.632,0,0,0,.867,14.233c.034.018.075.058.116.076l27.9,16.1a8.63,8.63,0,0,0,12.281-4.034,8.933,8.933,0,0,0,.692-3.446v-10.3h21.306a34.731,34.731,0,0,0,34.691-34.692V628.667a34.731,34.731,0,0,0-34.691-34.691",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup33);
export default __webpack_public_path__ + "static/media/Group 33.165dd595e3ba8f7b31d7abffba694589.svg";
export { ForwardRef as ReactComponent };